import styled from 'styled-components';
import { HashLink as Link } from 'react-router-hash-link';
import colors from '../../../../includes/colors';

export const List = styled.ul`
  list-style-type: none;
  display: flex;
  background-color: ${colors.darkBlue};
  padding-bottom: 0.6rem;
  padding-top: 0.6rem;
  justify-content: space-around;
  padding-left: 0;
  padding-right: 10px;
  position: sticky;
  top: 0px;
  z-index: 3;

  @media (min-width: 992px) {
    display: none;
  }
`;

export const Item = styled.li`
  margin: 0 5px;
  text-align: center;
`;

export const Action = styled(Link)`
  color: ${colors.white} !important;
  font-size: 0.88rem;

  @media (min-width: 480px) {
    font-size: 1rem;
  }
`;
